module.exports = __webpack_public_path__ + "static/media/Successimg.711b6e76.svg";